// src/analytics.js

// Your GA4 Measurement ID (from the script tag in index.html)
const GA_MEASUREMENT_ID = "G-NJQ5VZ178T";

// Safe wrapper so the app doesn't crash if GA isn't loaded yet
const safeGtag = (...args) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag(...args);
  } else {
    // Uncomment this if you want to debug when gtag isn't ready:
    // console.debug("gtag not ready", args);
  }
};

// SPA pageview tracking (for React Router)
export function trackPageView(path, title) {
  safeGtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: title || document.title,
    send_to: GA_MEASUREMENT_ID,
  });
}

// Generic custom event tracking
// Example: trackEvent({ action: "open_map", category: "ui", label: "header_button" })
export function trackEvent({ action, category, label, value, ...rest }) {
  if (!action) return;

  safeGtag("event", action, {
    // These are just custom params in GA4; you can see/register them in the GA UI
    event_category: category,
    event_label: label,
    value,
    send_to: GA_MEASUREMENT_ID,
    ...rest, // allow extra GA4-style parameters if you want (e.g., { item_id: "xyz" })
  });
}
